module.exports = __webpack_public_path__ + "img/check_green.3386ae5c.svg";